import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import TimePickerItem, { TIME_HOUR } from './TimePickerItems';
import TimePickerInput from '../TimePicker/TimePickerInput';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { TIME_MINUTE } from './TimePickerItems/index';
import cn from 'classnames';
import { InfoPropTypes } from 'components/Tooltip';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  root: {
    width: '200px',
    minHeight: '300px',
    backgroundColor: `${theme.palette.background.paper} !important`,
  },
  title: {
    padding: '.5rem 1rem',
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  timeClassNameColor: {
    color: theme.palette.text.primary,
  },
}));

const TimePickerNew = ({
  label,
  required,
  disabled,
  value,
  onChange,
  error,
  timeInterval = 5,
  maxMinuteInput,
  className,
  info,
}) => {
  const [open, setOpen] = useState(false);
  const [time, setTime] = useState();
  const classes = useStyles();
  const { t } = useTranslation();
  useEffect(() => {
    if (value) {
      const timeArray = value.split(':');
      setTime({ [TIME_HOUR]: timeArray[0], [TIME_MINUTE]: timeArray[1] });
    } else {
      setTime();
    }
  }, [value]);

  const updateTime = ({ category, value }) => {
    if (!isNaN(value)) {
      const newTime = { ...time, [category]: value };
      setTime(newTime);
      onChange(
        `${newTime ? newTime[TIME_HOUR] : '00'}:${
          newTime ? newTime[TIME_MINUTE] : '00'
        }`,
      );
    }
  };

  const toggleCalendar = () => setOpen(!open);

  return (
    <div className={cn(styles.timepickerWrapper, className)}>
      <TimePickerInput
        onChange={updateTime}
        required={required}
        label={label}
        disabled={disabled}
        error={error}
        toggleCalendar={toggleCalendar}
        time={time}
        timeInterval={timeInterval}
        maxMinuteInput={maxMinuteInput}
        info={info}
      />

      <Dialog
        open={open}
        onClose={toggleCalendar}
        maxWidth="xs"
        classes={{
          paper: classes.root,
        }}
      >
        <DialogTitle id="simple-dialog-title" className={classes.title}>
          {t('Select Time')}
        </DialogTitle>
        <TimePickerItem
          onUpdateTime={updateTime}
          time={time}
          timeInterval={timeInterval}
          timeClassName={classes.timeClassNameColor}
        />
      </Dialog>
    </div>
  );
};

TimePickerNew.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  timeInterval: PropTypes.number,
  className: PropTypes.string,
  info: InfoPropTypes,
  maxMinuteInput: PropTypes.number,
};

export default TimePickerNew;
